export default "__VITE_ASSET__duxTZ8wY__"